module.exports = "/_next/static/images/6419ed56ee254e051670c42ea023f80d-cartao-proximo-ao-olho-md@3x.jpg.webp";